module.exports = "<p>\n  promotion-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/promotion-page/promotion-page.component.html
// module id = ../../../../../src/app/promotion-page/promotion-page.component.html
// module chunks = main